
    import './styles.scoped.css';
    export default {
  "custom-range": "awsui_custom-range_16zmw_3c5g3_99",
  "custom-range--no-padding": "awsui_custom-range--no-padding_16zmw_3c5g3_105",
  "custom-range-form-controls": "awsui_custom-range-form-controls_16zmw_3c5g3_109",
  "custom-range-duration": "awsui_custom-range-duration_16zmw_3c5g3_113",
  "custom-range-unit": "awsui_custom-range-unit_16zmw_3c5g3_114",
  "vertical": "awsui_vertical_16zmw_3c5g3_120",
  "custom-range-duration-input": "awsui_custom-range-duration-input_16zmw_3c5g3_131",
  "custom-range-unit-select": "awsui_custom-range-unit-select_16zmw_3c5g3_132",
  "relative-range-radio-group": "awsui_relative-range-radio-group_16zmw_3c5g3_136"
};
  